export default __webpack_public_path__ + "static/media/52_1_2.9fdda8b9.png";